import { FocusMonitor } from '@angular/cdk/a11y';
import * as KeyCode from '@angular/cdk/keycodes';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[nebulaTrapKeyboadEvents]'
})
export class NebulaTrapKeyboardEventsDirective {

  private _inputTypes = 'input, button:not(:disabled), a, mat-list-item, mat-selection-list';

  constructor(private el: ElementRef, private monitor: FocusMonitor) { }

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    // tslint:disable:deprecation
    if (e.keyCode === KeyCode.TAB) {
      this._handleTabEvent(e, !e.shiftKey);
    }
    // tslint:enable:deprecation
  }

  private _handleTabEvent($event: Event, forward: boolean) {
    $event.stopPropagation();
    $event.preventDefault();
    const elements: Array<HTMLElement> = Array.from(this.el.nativeElement.querySelectorAll(this._inputTypes));
    if (elements.length === 0) {
      return;
    }
    let index = elements.findIndex(e => e === document.activeElement);
    index = (index + (forward ? 1 : -1) + elements.length) % elements.length;
    this._focusOnElement(elements[index]);
  }

  private _focusOnElement(element: HTMLElement) {
    setTimeout(() => {
      this.monitor.focusVia(element, 'keyboard');
    });
  }

}
